import { SVGAttributes } from "react";

function PayloadIcon(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M19 3.6A11 11 0 0 0 13 1v2a9 9 0 0 1 4.6 2L19 3.6zM11 3V1c-2.3.3-4.4 1.2-6 2.6L6.4 5A9 9 0 0 1 11 3zM5 6.4 3.6 5A11 11 0 0 0 1 11h2a9 9 0 0 1 2-4.6zM21 11h2a11 11 0 0 0-2.6-6L19 6.4a9 9 0 0 1 2 4.6zM7 12l3.4 1.6L12 17l1.6-3.4L17 12l-3.4-1.6L12 7l-1.6 3.4z" />
      <path d="M12 21a9 9 0 0 1-7.5-4H7v-2H1v6h2v-2.7a11 11 0 0 0 19.4-2.9l-2-.4a9 9 0 0 1-8.4 6z" />
    </svg>
  );
}

export default PayloadIcon;
